module.exports = __webpack_public_path__ + "img/I-BOS-1118-0.a8ecc541.png";